// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2-Bad","container":"styles_container__igTb0","title":"styles_title__1ocam","wrapper":"styles_wrapper__2mqP3","answer":"styles_answer__1Qgj6"};